// Libraries
import { MutationTuple, useMutation } from "@apollo/client";
// API
import { IMPORT_CSV_FILE } from "api/Import/CustomImport/mutations";
import { ImportCsv, ImportCsvVariables } from "api/Import/CustomImport/types/ImportCsv";

export const useMutationImportCsv = (): MutationTuple<ImportCsv, ImportCsvVariables> =>
  useMutation<ImportCsv, ImportCsvVariables>(IMPORT_CSV_FILE);
